import { Location } from 'history';

// leading `/`, followed by either a number or a UUID, followed by a trailing `/` or end of string
const REGEX_PARAM =
  /(\/)(?:\d+|[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12})(\/|$)/gi;

export const getPageFromLocation = (location: Location<unknown>) => {
  const path = location.pathname.replace(REGEX_PARAM, '$1*$2');
  const hash = location.hash;
  return `${path}${hash}`;
};
